module.exports = __webpack_public_path__ + "static/img/bcg_r.f95d9bac.png";